const $doc = $(document);

/**
 * @param  {String} elementClass             Selector for the element to hide
 * @param  {String} triggerClass             Selector for the trigger
 * @param  {String} elementVisibleClass      Classname to remove from the element
 * @param  {String} triggerActiveClass       Classname to remove from the trigger
 * @param  {String} globalVisibleClass       Classname to remove from the `html` tag
 */
var clickHandlers = [
	{
		elementClass: 'widget-filter',
		triggerClass: 'filter-trigger',
		elementVisibleClass: 'active',
		triggerActiveClass: 'active',
		globalVisibleClass: 'overlay no-scroll'
	}
];

$doc
	.on('click', '.filter-trigger', function(e) {
		e.preventDefault();

		triggerFilter();
	})
	.on('click', '.btn-filter', function(e) {
		e.preventDefault();

		const $this = $(this);
		const $block = $(`[data-id="${$this.data('id')}"][data-type="${$this.data('type')}"]`);

		triggerFilter();

		$block.find('.bc-sf-filter-block-title span').addClass('up');
		$block.find('.bc-sf-filter-block-content').slideDown();
	})
	.on('click touchend', function(event) {
		if ($('.widget-filter.active').length) {
			clickHandlers.forEach(function(clickHandler) {
				hideElementOnDocumentClick(event, clickHandler);
			});
		}
	});

function triggerFilter() {
	$('.widget-filter, .filter-trigger').toggleClass('active');
	$('.wrapper').toggleClass('overlay');
	$('body').toggleClass('no-scroll');
}

function hideElementOnDocumentClick(event, clickHandler) {
	var $target = $(event.target);
	var $wrapper = $('.wrapper');
	var $html = $('html, body');

	var elementClass = clickHandler.elementClass;
	var triggerClass = clickHandler.triggerClass;
	var elementVisibleClass = clickHandler.elementVisibleClass;
	var triggerActiveClass = clickHandler.triggerActiveClass;
	var globalVisibleClass = clickHandler.globalVisibleClass;

	if (
		!$target.hasClass(elementClass) &&
		!$target.parents('.' + elementClass).length &&
		!$target.hasClass(triggerClass) &&
		!$target.parents('.' + triggerClass).length
	) {
		$('.' + elementClass).removeClass(elementVisibleClass);
		$('.' + triggerClass).removeClass(triggerActiveClass);

		$wrapper.removeClass(globalVisibleClass);
		$html.removeClass(globalVisibleClass);
	}
}



// WEBPACK FOOTER //
// ../assets/js/filter.js